var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_home",
    "data-name": "icon - home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M20.994,13.65a.788.788,0,0,1-.454-.144h0L12.987,8.157,5.46,13.505a.789.789,0,0,1-1.1-.187l-.516-.729a.787.787,0,0,1,.187-1.1l8.512-6.028a.791.791,0,0,1,.911,0l8.512,6.028a.787.787,0,0,1,.187,1.1l-.515.729a.79.79,0,0,1-.645.332M13,5.919a.19.19,0,0,0-.109.034L4.379,11.98a.188.188,0,0,0-.045.262l.516.729a.189.189,0,0,0,.263.045l7.553-5.348a.577.577,0,0,1,.668,0l7.553,5.348a.189.189,0,0,0,.262-.045l.516-.729a.189.189,0,0,0,.032-.14.18.18,0,0,0-.077-.121L13.108,5.953A.184.184,0,0,0,13,5.919m6.744,13.962v-6.53a.3.3,0,1,0-.6,0v6.53a.2.2,0,0,1-.2.2H10.862v-1.86h.384a2.547,2.547,0,0,0,1.744-.6,2.068,2.068,0,0,0,.69-1.62,1.977,1.977,0,0,0-.7-1.594,2.676,2.676,0,0,0-1.77-.564H9.544a.488.488,0,0,0-.489.488v5.746h-2a.2.2,0,0,1-.2-.2v-6.53a.3.3,0,1,0-.6,0v6.53a.8.8,0,0,0,.8.8h2.3a.3.3,0,0,0,.3-.3V14.447h1.556a2.1,2.1,0,0,1,1.385.425,1.387,1.387,0,0,1,.485,1.134,1.468,1.468,0,0,1-.489,1.17,1.935,1.935,0,0,1-1.346.447h-.61a.374.374,0,0,0-.374.374v2.384a.3.3,0,0,0,.3.3h8.382a.8.8,0,0,0,.8-.8m-8.6-2.715h-.469a.415.415,0,0,1-.415-.415V15.314a.415.415,0,0,1,.415-.415h.5a1.315,1.315,0,0,1,.9.311,1.065,1.065,0,0,1,.366.837c0,.418-.167,1.119-1.291,1.119m-.284-.6h.284c.638,0,.692-.256.692-.519a.473.473,0,0,0-.163-.386.725.725,0,0,0-.5-.162h-.313Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.7807468f659356979d3c851c09aae127.svg";
export { ForwardRef as ReactComponent };